import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import { getPeriodForPresentation } from '../../services/utils';

import OrdersInner from './ordersInner';
import ExportOrders from '../../components/ExportOrders';

//Actions
import * as ordersActions from '../../actions/ordersActions';

class LastTraded extends React.Component {
    constructor(props) {
		super(props);
        this.props.actions.getOrders('lastTraded');
	}

    getBuyer(order) {
        if (order.intent === 'BUY') {
            return order.creator_counterpart;
        }

        return order.accepter_counterpart;
    }

    getSeller(order) {
        if (order.intent === 'SELL') {
            return order.creator_counterpart;
        }

        return order.accepter_counterpart;
    }

    getProductName(order) {
        const { products } = this.props.user.userInfo;
        const theProduct = (products || []).find(product => product.id === order.product_id);
        return theProduct && theProduct.short_name || '';
    } 

    parseDate(date) {
        return moment(date).tz("America/New_York").format('MMMM Do');
    }

    download(event, order_id) {
        event.stopPropagation();
        event.preventDefault();

        let schemeAuth = '';
        if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
            var scheme = 'http';
            var authority = 'localhost';
            var port = '8081';
            schemeAuth = scheme+'://'+authority+':'+port;
        }

        window.location = `${schemeAuth}/api/v1/orders/${order_id}/contract`;
    }

    render() {
        const { orders } = this.props;
        const { getOrder, showOrderPopup } = this.props.actions;

        let schemeAuth = '';
        if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
            var scheme = 'http';
            var authority = 'localhost';
            var port = '8081';
            schemeAuth = scheme+'://'+authority+':'+port;
        }

        return (
            <div>
                <h1>Last 500 traded orders</h1>
                <ExportOrders path="lastclosedorders" />
                <div className='online-market-container'>
                    <table>
                        <tbody>
                            {(orders && orders.data || []).map(item =>
                                <tr
                                    key={'order'+item.id}
                                    onClick={() => getOrder(item.id, 'edit-finalised', showOrderPopup)}
                                    className='order-table-row'>
                                    <td style={{ minWidth: 90 }}>{this.parseDate(item.accepted_time)}</td> 
                                    <td>Contract ID: {item.contract_numbers}</td>
                                    <td>{this.getProductName(item)} ({item.contract_type})</td> 
                                    <td>{getPeriodForPresentation(item.trading_period_prefix, item.trading_period)}</td>
                                    <td style={{ minWidth: 80 }}>{item.quantity} {item.unit_abbreviation}</td> 
                                    <td style={{ minWidth: 80 }}>{item.price} {item.currency_id}</td> 
                                    <td>Buyer: {this.getBuyer(item)}</td> 
                                    <td>Seller: {this.getSeller(item)}</td>
                                    <td><button className="download-button" onClick={ev => this.download(ev, item.id)}>Get contract</button></td>
                                </tr>                   
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        orders: state.orders,
        user: state.user,
    }),
    dispatch => ({
        actions: bindActionCreators({...ordersActions}, dispatch)
    })
)(LastTraded);



// WEBPACK FOOTER //
// ./source/screens/orders/LastTraded.js